var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.mainStyle)},[_c('vue-headful',{attrs:{"title":_vm.data.title,"head":{
      'link[rel=icon]': {href: _vm.data.favicon_uri}
  }}}),_vm._v(" "),_c('app-header',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('div',[_c('section',{staticClass:"page-info set-bg",style:({ backgroundImage: ("url('" + (_vm.data.bg_img_url + '?v='+_vm.data.last_updated) + "')")})})]),_vm._v(" "),_c('router-view',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('app-footer',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284f864c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 